module.exports = __webpack_public_path__ + "static/img/service_introduce_JP03_zh_h5.675f1fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_JP03_zh_h5.png
// module id = Bj8Z
// module chunks = 34